<template>
  <div class="payment-section" v-loading="true"/>
</template>

<script>
export default {
  name: 'onboarding',
  data() {
    return { };
  },
  mounted() {
    window.parent.postMessage(
      {
        event: 'payment-transaction-success',
        data: true,
      },
      '*',
    );
  },
};
</script>
<style scoped lang="scss">
  @import "~@/styles/variables.scss";
  .payment-section {
    height: 100%;
  }
</style>
